<template>
    <div>
        <v-row>
            <v-col cols="12" md="12">
                <CompanySnapshot />
            </v-col>
            <v-col cols="12" md="6">
                <CompanyContacts />
            </v-col>
            <v-col cols="12" md="6">
                <CompanyDetails />
                <CompanyBilling />
            </v-col>
        </v-row>
    </div>
</template>
<script>
import moment from 'moment'
import CompanySnapshot from './CompanySnapshot'
import CompanyContacts from './CompanyContacts.vue'
import CompanyBilling from './CompanyBilling.vue'
import CompanyDetails from './CompanyDetails.vue'
    export default {
        name: 'ClientDetails',
        components: {
            CompanySnapshot,
            CompanyContacts,
            CompanyBilling,
            CompanyDetails
        },
        data(){
            return {
            }
        },
        methods: {
        },
        mounted(){
        }
    }
</script>
<style>
</style>